import { tw } from "@careinfo/tailwind";
import {
  File,
  FileArchive,
  FileAudio,
  FileCheck,
  FileImage,
  FileText,
  FileVideo,
  FileX,
} from "lucide-react";

const isValidUrl = (str: string): boolean => {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
};

const getFileNameFromUrl = (url: string): string => {
  return decodeURIComponent(url.split("/").pop()?.split("?")[0] || "file");
};

const getFileIconComponent = (fileName: string) => {
  const ext = fileName.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "pdf":
    case "doc":
    case "docx":
    case "txt":
      return (
        <>
          <FileText className={tw`w-6 h-6 text-blue-600`} />{" "}
          <span>Document</span>
        </>
      );
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
      return (
        <>
          <FileImage className={tw`w-6 h-6 text-green-600`} />
          <span>Image</span>
        </>
      );
    case "mp3":
    case "wav":
      return (
        <>
          <FileAudio className={tw`w-6 h-6 text-purple-600`} />
          Audio
        </>
      );
    case "mp4":
    case "avi":
      return (
        <>
          <FileVideo className={tw`w-6 h-6 text-pink-600`} />
          <span>Video</span>
        </>
      );
    case "zip":
    case "rar":
    case "7z":
      return (
        <>
          <FileArchive className={tw`w-6 h-6 text-yellow-600`} />
          <span>Zip</span>
        </>
      );
    case "json":
      return (
        <>
          <FileCheck className={tw`w-6 h-6 text-teal-600`} />
          <span>Json</span>
        </>
      );
    case "exe":
      return (
        <>
          <FileX className={tw`w-6 h-6 text-red-600`} />
          <span>Application</span>
        </>
      );
    default:
      return (
        <>
          <File className={tw`w-6 h-6 text-gray-500`} />
          <span>File</span>
        </>
      );
  }
};

const LastMessage = ({ message }: { message: string }) => {
  if (!message) return null;

  if (!isValidUrl(message)) {
    return (
      <p
        className={tw`text-sm text-gray-400 overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        }}
      >
        {message}
      </p>
    );
  }

  const fileName = getFileNameFromUrl(message);

  return (
    <div className={tw`text-sm text-gray-800 whitespace-pre-wrap break-words`}>
      <div
        className={tw`flex items-center gap-2 p-2  rounded-md w-fit  transition`}
      >
        {getFileIconComponent(fileName)}
      </div>
    </div>
  );
};

export default LastMessage;
